module.exports = __webpack_public_path__ + "static/img/coupon-empty.d3b5a88e.png";